import * as React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
// import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import "./AllowAccessIOS.css"
import { listOfApps, safariIcon, selectDone, turnItOn, webSetting } from '../../../images/btnIcons';
import { SpeakerContext } from '../../../context/SpeakerContext';
import { useContext } from 'react';
import { Button } from 'unified-ui-components-library';



const AllowAccessIOS = ({ startVideo }) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const { handlebackBtnDisplay, handleAudioIconDisplay } = useContext(SpeakerContext)

    React.useEffect(()=>{
        handlebackBtnDisplay(true)
        handleAudioIconDisplay(false)
        return ()=>{
            handlebackBtnDisplay(false)
            handleAudioIconDisplay(true)
        }
    },[])


    return (
        <div className="allowAccessIOSWrapper">
            <h5>Allow Camera & Microphone access</h5>
            <Accordion className='IOSAccordianWrapper' expanded={expanded == 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className='headingAccordian'
                >
                    Safari Settings
                </AccordionSummary>
                <AccordionDetails className="accordianInner">
                    <ol className='allowAccessList'>
                        <li>
                            <p>On your browser call tab, tap on the <span>AA</span> icon at the bottom left.</p>
                        </li>
                        <li>
                            <p>When the popup menu appears, select <span>Website Settings.</span></p>
                            <img className='imgStyle' src={webSetting} alt="browser-setting-image" />
                        </li>
                        <li>
                            <p>When the settings window opens, ensure your Camera & Microphone are both set to <span>Allow</span>.</p>
                        </li>
                        <li>
                            <p>Select <span>Done</span> to save the new settings.</p>
                            <img className='imgStyle' src={selectDone} alt="browser-setting-image" />
                        </li>
                    </ol>
                </AccordionDetails>
            </Accordion>
            <Accordion className='IOSAccordianWrapper' expanded={expanded == 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className='headingAccordian'
                >
                    Chrome Settings
                </AccordionSummary>
                <AccordionDetails className="accordianInner">
                    <ol className='allowAccessList'>
                        <li>
                            <p>Open the <span>Settings app</span> on your iPhone.
                                <img className='safariIcon' src={safariIcon} alt="browser-setting-image" /></p>
                        </li>
                        <li>
                            <p>Scroll down and choose the <span>Chrome</span> option from the list of apps.</p>
                            <img className='imgStyle' src={listOfApps} alt="browser-setting-image" />
                        </li>

                        <li>
                            <p>Tap the button to the right of Camera or Microphone to <span>turn it on.</span></p>
                            <img className='imgStyle' src={turnItOn} alt="browser-setting-image" />
                        </li>
                    </ol>
                </AccordionDetails>
            </Accordion>
            <div className="btnWrapper">
                <Button
                    buttonType='primary'
                    width="264"
                    onClick={startVideo}
                >
                    Next
                </Button>
            </div>
        </div>
    )
}

export default AllowAccessIOS